/**
*
* Tag
* tag with remove button
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { CloseButton } from 'react-bootstrap';

const Wrapper = styled.div`
  background-color: rgb(230, 230, 230);
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  height: 24px;
  min-width: 0px;
  cursor: default;
`;

const InnerWrapper = styled.div`
  border-radius: 2px;
  color: rgb(51, 51, 51);
  font-size: 75%;
  font-weight: 600;
  overflow: hidden;
  padding: 3px 3px 3px 0px;
  text-overflow: ellipsis;
  white-space: nowrap;
  box-sizing: border-box;
`;

function Tag(props) {
  const { children, onRemove, ...rest } = props;
  return (
    <Wrapper onClick={(ev) => ev.stopPropagation()} {...rest}>
      <InnerWrapper>
        {children}
      </InnerWrapper>
      {onRemove && (
        <CloseButton className="me-2" onClick={onRemove} />
      )}
    </Wrapper>
  );
}

Tag.propTypes = {
  children: PropTypes.node,
  onRemove: PropTypes.func,
};

export default Tag;
